<!-- SUB BANNER -->
<section class="section-sub-banner awe-parallax bg-16">

    <div class="awe-overlay"></div>

    <div class="sub-banner">
        <div class="container">
            <div class="text text-center">
                <!-- <h2>RESERVATION</h2> -->
                <p></p>
            </div>
        </div>

    </div>

</section>
<!-- END / SUB BANNER -->


<!-- <div class="col-md-4 col-lg-3 bg-white">

    <div class="reservation-sidebar">

        <div class="reservation-room-selected bg-gray">

            <h2 class="reservation-heading">PRICE CALCULATOR</h2>

            <div class="reservation-room-seleted_item">

                <div class="reservation-room-seleted_package">
                    <h6>Rooms</h6>
                    <ul>
                        <li>
                            <span>Standard (Single)</span>
                            <span>- $200 X 2</span>
                            <span>$400.00</span>
                        </li>
                        <li>
                            <span>Deluxe (Single)</span>
                            <span>- $120 X 4</span>
                            <span>$480.00</span>
                        </li>
                    </ul>

                </div>

                <div class="reservation-room-seleted_total-room">
                    Sub-Total
                    <span class="reservation-amout">$880.00</span>
                </div>

            </div>

            <div class="reservation-room-seleted_item">

                <div class="reservation-room-seleted_package">
                    <h6>Tours</h6>
                    <ul>
                        <li>
                            <span>Soweto</span>
                            <span>- $50 X 4</span>
                            <span>$200.00</span>
                        </li>
                        <li>
                            <span>Union Building</span>
                            <span>- $40 X 4</span>
                            <span>$160.00</span>
                        </li>
                    </ul>

                </div>

                <div class="reservation-room-seleted_total-room">
                    Sub-Total
                    <span class="reservation-amout">$470.00</span>
                </div>

            </div>

            <div class="reservation-room-seleted_total bg-blue">
                <label>OVERALL TOTAL</label>
                <span class="reservation-total">$470.00</span>
            </div>
            <div class="row">
                <div id="pay-button" class="col-sm-push-2 col-sm-10">
                    <div id="paypal-button-container"></div>
                </div>
            </div>

        </div>

    </div>

</div> -->

<div class="container">
    <div class="row">
        <div class="col-md-12">
            <router-outlet></router-outlet>
        </div>
        <!-- <div class="col-md-12 bg-white"> -->

        <div class="col-md-12 reservation-room-selected bg-gray">
            <div class="reservation-room-seleted_total bg-blue">
                <div class="pull-left">
                    <label>Paid For Conference?:
                        <span *ngIf="paidForConference$ | async as paid; else notPaid">YES</span>
                    </label>
                </div>
                <div class="pull-right">
                    <label style="margin-right:10px;">Paid For Accommodation?
                        <span *ngIf="paidForAccommodation$ | async as paid; else notPaid">YES</span>
                    </label>
                </div>
                <ng-template #notPaid>NOT YET</ng-template>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="panel panel-success">
                        <div class="panel-heading">
                            <h2 class="panel-title">Conference Total:
                                <span *ngIf="overallConferenceFees$ | async as fees">${{fees.toFixed(2)}} or R{{(fees * 10.91).toFixed(2)}}</span>
                            </h2>
                        </div>
                        <div class="panel-body">
                            <div id="left-pay-button" class="col-sm-push-2 col-sm-10">
                                <div [hidden]="(paidForConference$ | async)" id="conference-button-container"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="panel panel-success">
                        <div class="panel-heading">
                            <h2 class="panel-title">Accommodation Total:
                                <span *ngIf="overallTotalPrice$ | async as fees">${{fees.toFixed(2)}}</span>
                            </h2>
                        </div>
                        <div class="panel-body">
                            <div id="right-pay-button" class="col-sm-push-2 col-sm-10">
                                <p *ngIf="(paidForAccommodation$ | async)">A follow up email with details of the hotels for each booking will be sent by email in a
                                    due course. You can however click on the confirmation buttons above to print the confirmation
                                    letters for visa acquisition if applicable.
                                </p>
                                <div [hidden]="(paidForAccommodation$ | async)" id="accommodation-button-container"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="reservation-room-seleted_total bg-blue">
                <p>Please note that you are to make the separate payments, as indicated above, for the conference and your accommodation.</p>
            </div>

            <!-- <div class="reservation-room-seleted_total bg-blue">
                <label>OVERALL TOTAL COST</label>
                <span class="reservation-total">${{(overallTotalPrice$ | async) + 110}}</span>
            </div>
            <div class="pull-right">
                <div id="pay-button" class="col-sm-push-2 col-sm-10">
                    <div id="paypal-button-container"></div>
                </div>
            </div> -->

        </div>

        <!-- </div> -->
    </div>
</div>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/booking-shell/booking-shell.component.html